import { Component } from 'react';
import PropTypes from 'prop-types';
import Pagination from '@mui/material/Pagination';
import styles from './styles';
import { withStyles } from 'tss-react/mui';
// Wrapper around MUI v5 <Pagination>, replacing the dead
// `material-ui-flat-pagination` package. The component's external
// API (data, onChange) is unchanged: callers pass current/total/
// itemsPerPage and receive a 1-based page number on change.
class CustomPagination extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    data: PropTypes.shape({
      itemsPerPage: PropTypes.number,
      current: PropTypes.number,
      totalItemsCount: PropTypes.number,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
  };

  shouldComponentUpdate(nextProps) {
    const { data } = this.props;
    return nextProps.data !== data;
  }

  onChange = (_event, page) => {
    this.props.onChange(page);
  };

  render() {
    const { classes, data } = this.props;
    if (!data.itemsPerPage || data.itemsPerPage >= data.totalItemsCount) return null;

    const count = Math.ceil(data.totalItemsCount / data.itemsPerPage);

    return (
      <div className={classes.pagination}>
        <Pagination
          color="primary"
          count={count}
          page={data.current}
          onChange={this.onChange}
          showFirstButton
          showLastButton
        />
      </div>
    );
  }
}

export default withStyles(CustomPagination, styles);
